import React from 'react'

export default function Container({children}) {
  return (
    <div className="max-w-6xl mx-auto p-6 lg:p-10 min-h-full">
      {children}
    </div>
  )
}
